import { Getter } from "vuex";
import { IState } from './state';

const items: Getter<IState, IState> = (state) => state.items;
const total: Getter<IState, IState> = (state) => state.total;
const numberToShow: Getter<IState, IState> = (state) => state.numberToShow;

export default {
	items, numberToShow, total,
}
